<template>
  <li
    class="notification__item"
    v-bind:class="{ first: showOne }"
    @click="navigate(item)"
    @mouseenter="showBackIcon"
    @mouseleave="showIcon"
  >
    <div
      class="item__icon item__icon--corner"
      v-html="getRightIcon(item)"
    ></div>
    <!--<div class="item__icon item__icon--close" v-html="iconClose"></div> -->
    <div class="item__cnt">
      <div
        class="item__icon item__icon--catalog avatar"
        v-html="getContent(item)"
      ></div>
      <h6 class="item__title">{{ item.text || item.title }}</h6>
    </div>
    <p class="item__group">{{ getNotificationType(item.type) }}</p>
  </li>
</template>

<script>
import iconClose from "@/assets/svg/new/back.svg";
import iconPassedYouRight from "@/assets/svg/new/PASSED-YOU-RIGHT.svg";
import iconRewardsRight from "@/assets/svg/new/REWARDS-RIGHT.svg";
import iconRewardsLeft from "@/assets/svg/new/REWARDS-LEFT.svg";
import iconProfileRight from "@/assets/svg/new/PROFILE-RIGHT.svg";
import iconProfileLeft from "@/assets/svg/new/PROFILE-LEFT.svg";
import iconMissionRight from "@/assets/svg/new/MISSIONS-RIGHT.svg";
import iconMissionLeft from "@/assets/svg/new/MISSIONS-LEFT.svg";
import iconGenericRight from "@/assets/svg/new/GENERIC-RIGHT.svg";
import iconGenericLeft from "@/assets/svg/new/GENERIC-LEFT.svg";

export default {
  name: "NotificationListItem",
  props: ["item", "showOne"],
  data() {
    return {
      iconClose,
      upHere: false,
      timeout: null
    };
  },

  methods: {
    showBackIcon() {
      this.timeout = setTimeout(() => {
        this.upHere = true;
      }, 200);
    },
    showIcon() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.upHere = false;
      }, 200);
    },
    navigate(item) {
      let link = null;

      const generalRoutes = {
        leaderBoard: "/leaderboard",
        "leaderboard-friend": "/leaderboard",
        mission: "/mission",
        reward: `/catalog/rewards?rewardId=${item.reward_id}`,
        profile: "/settings/profile",
        "profile-general": "/settings/profile",
        "mission-general": "/actions",
        "reward-general": "/catalog"
      };

      link = generalRoutes[item.type];

      //mission redirect route
      if (item.mission_type) {
        const missionRoutes = {
          survey: `/survey/${item.mission_id}`,
          question: `/question/${item.mission_id}`,
          instantwin: `/instantwin/${item.mission_id}`,
          information: `/information/${item.mission_id}`,
          prediction: `/prediction/${item.mission_id}`,
          "event.video": `/video/${item.mission_id}`,
          "instantwin.random": `/instantwinRandom/${item.mission_id}`,
          "invite.friend": "invite",
          "insert.code": "/code",
          "mobile.verified": "verify/mobile"
        };

        if (item.mission.resource.type_of_static) {
          link = missionRoutes[item.mission.resource.type_of_static];
        } else {
          link = missionRoutes[item.mission_type];
        }
      }

      // we need to pass preselectedTab prop to navigate to current tab
      if (item.type === "profile" && item.section) {
        link = { path: link, params: { preselectedTab: item.section } };
      }

      if (item.type === "link") {
        window.open(item.link);
        return;
      }

      this.$router.push(link);
    },
    getContent(notification) {
      if (this.upHere) {
        return this.getRightIcon(notification);
      } else {
        return this.getLeftIcon(notification);
      }
    },
    getLeftIcon(notification) {
      if (notification.avatar) {
        return `<img src="${notification.avatar}" />`;
      }
      const icons = {
        "leaderboard-friend": `<div class="no-avatar secondary-bg" />`,
        "reward-general": iconRewardsLeft,
        reward: iconRewardsLeft,
        profile: iconProfileLeft,
        "profile-general": iconProfileLeft,
        "mission-general": iconMissionLeft,
        mission: iconMissionLeft
      };

      return icons[notification.type] || iconGenericLeft;
    },
    getRightIcon(notification) {
      const icons = {
        "leaderboard-friend": iconPassedYouRight,
        "reward-general": iconRewardsRight,
        reward: iconRewardsRight,
        profile: iconProfileRight,
        "profile-general": iconProfileRight,
        "mission-general": iconMissionRight,
        mission: iconMissionRight
      };
      return icons[notification.type] || iconGenericRight;
    },
    getNotificationType(key) {
      const hash = {
        "mission-general": this.$i18n.t("Vai alle missioni"),
        mission: this.$i18n.t("Vai alla missione"),
        "reward-general": this.$i18n.t("Vai al catalogo"),
        reward: this.$i18n.t("Vai al prodotto"),
        "profile-general": this.$i18n.t("Vai al profilo"),
        profile: this.$i18n.t("Vai al profilo"),
        leaderBoard: this.$i18n.t("Vai alla classifica"),
        link: this.$i18n.t("Vai al link")
      };
      return hash[key] || key;
    }
  }
};
</script>

<style lang="scss" scoped>
.notification__item {
  background: #b090f2;
  color: #fff;
  padding: 15px;
  padding-top: 25px;
  border-radius: 5px;
  box-shadow: 0 6px 13px 0 rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 1;
  margin-bottom: 10px;
  cursor: pointer;
}

.first {
  overflow: visible;
  margin-bottom: 30px;
  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 5px;
  }

  &::before {
    bottom: -10px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
    height: 10px;
    width: 95%;
    z-index: 1;
    background: #d3c8eb;
  }

  &::after {
    bottom: -19px;
    height: 9px;
    width: 91%;
    background: #d8cdf1;
  }
}

.item__icon--corner {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 50px;
  height: 50px;
}
.item__icon--catalog {
  margin: 0 15px 0 20px;
  width: 37px;
  height: 37px;
  align-self: center;
}

.item__icon {
  ::v-deep svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.item__icon--close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 15px;
  height: 15px;
  background-color: #fff;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: coral;
  }

  ::v-deep svg {
    width: 50%;
    height: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.item__cnt {
  display: flex;
  position: relative;
  z-index: 2;
}

.item__title {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}

.item__group {
  text-align: center;
  font-size: 12px;
  margin-top: auto;
}
.item__icon {
  transition: 0.5s all;
}

.notification__item:hover {
  .item__icon--catalog {
    transform: rotateY(360deg);
  }
}
</style>
